"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import SelectTherapist from "./choose-therapist";

interface MobileStickyBookingCtaProps {
  therapistSlug: string;
  isOfferingCouplesTherapy: boolean;
  couplesPrice?: number;
  defaultPrice: number;
  offersIntroCall?: boolean;
}

export default function MobileStickyBookingCta({
  therapistSlug,
  isOfferingCouplesTherapy,
  couplesPrice,
  defaultPrice,
  offersIntroCall,
}: MobileStickyBookingCtaProps) {
  const [showSticky, setShowSticky] = useState(false);

  useEffect(() => {
    const heroCtaElement = document.getElementById("hero-cta");
    if (!heroCtaElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowSticky(!entry?.isIntersecting);
      },
      { threshold: 0 },
    );

    observer.observe(heroCtaElement);
    return () => observer.disconnect();
  }, []);

  if (!showSticky) return null;

  return createPortal(
    <div className="fixed inset-x-0 bottom-0 z-20 border-t bg-background p-4 shadow-lg lg:hidden">
      <SelectTherapist
        label="Zakaži seansu"
        variant="default"
        therapistSlug={therapistSlug}
        showCouplesOption={isOfferingCouplesTherapy}
        couplesPrice={couplesPrice}
        defaultPrice={defaultPrice}
        hideTeaser
        compactSelector
        offersIntroCall={offersIntroCall}
      />
    </div>,
    document.body,
  );
}
